import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import './styles.css';

const isNative = () => !!(window as any).Capacitor?.isNativePlatform?.();

async function boot() {
  if (isNative()) {
    // Inside the iOS app: register native notifications, downloads, haptics, resume.
    const { installNativePlatform } = await import('./native/capacitor');
    await installNativePlatform().catch((e) => console.error('native platform init failed', e));
  }
  createRoot(document.getElementById('root')!).render(<App />);
}
boot();
